// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__18dQd","content":"Consent_content__3Skpl","footer":"Consent_footer__3B1Q7"};